import { type PaginationState } from "@kazaar-platform/design-system";
import { useState } from "react";

import { type CustomSortingState } from "@/helpers/tables";
import { useGetDeliveredTasks } from "@/hooks";

export const useDeliveredTasks = () => {
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 1,
    pageSize: 10,
  });
  const [sorting, setSorting] = useState<CustomSortingState | undefined>(
    undefined
  );

  const { data: deliveredTasksData, isLoading: isDeliveredTasksLoading } =
    useGetDeliveredTasks({
      limit: pagination.pageSize,
      offset: (pagination.pageIndex - 1) * pagination.pageSize,
    });

  return {
    deliveredTasks: deliveredTasksData?.data?.page || [],
    totalRows: deliveredTasksData?.data?.total || 0,
    isLoading: isDeliveredTasksLoading,
    pagination,
    sorting,
    setPagination,
    setSorting,
  };
};
